const middleware = {}

middleware['auth-admin'] = require('../middleware/auth-admin.js')
middleware['auth-admin'] = middleware['auth-admin'].default || middleware['auth-admin']

middleware['auth-owner'] = require('../middleware/auth-owner.js')
middleware['auth-owner'] = middleware['auth-owner'].default || middleware['auth-owner']

middleware['auth-qontak-user'] = require('../middleware/auth-qontak-user.js')
middleware['auth-qontak-user'] = middleware['auth-qontak-user'].default || middleware['auth-qontak-user']

middleware['block-agent-integrations'] = require('../middleware/block-agent-integrations.js')
middleware['block-agent-integrations'] = middleware['block-agent-integrations'].default || middleware['block-agent-integrations']

middleware['inbox-sunset-redirect'] = require('../middleware/inbox-sunset-redirect.js')
middleware['inbox-sunset-redirect'] = middleware['inbox-sunset-redirect'].default || middleware['inbox-sunset-redirect']

middleware['init-permissions'] = require('../middleware/init-permissions.js')
middleware['init-permissions'] = middleware['init-permissions'].default || middleware['init-permissions']

middleware['login'] = require('../middleware/login.js')
middleware['login'] = middleware['login'].default || middleware['login']

middleware['redirection'] = require('../middleware/redirection.js')
middleware['redirection'] = middleware['redirection'].default || middleware['redirection']

middleware['route-guard'] = require('../middleware/route-guard.js')
middleware['route-guard'] = middleware['route-guard'].default || middleware['route-guard']

middleware['settings'] = require('../middleware/settings.js')
middleware['settings'] = middleware['settings'].default || middleware['settings']

middleware['sso-callback'] = require('../middleware/sso-callback.js')
middleware['sso-callback'] = middleware['sso-callback'].default || middleware['sso-callback']

middleware['usman-init'] = require('../middleware/usman-init.js')
middleware['usman-init'] = middleware['usman-init'].default || middleware['usman-init']

middleware['utils'] = require('../middleware/utils.js')
middleware['utils'] = middleware['utils'].default || middleware['utils']

middleware['version-switcher'] = require('../middleware/version-switcher.js')
middleware['version-switcher'] = middleware['version-switcher'].default || middleware['version-switcher']

export default middleware
